import { render, staticRenderFns } from "./DayaDukungBannerDialog.vue?vue&type=template&id=ce06aee6&scoped=true"
import script from "./DayaDukungBannerDialog.vue?vue&type=script&lang=js"
export * from "./DayaDukungBannerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce06aee6",
  null
  
)

export default component.exports